import React, { PureComponent, Fragment } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

import { PieChart, Pie, Cell } from "recharts";

import { Metric, selectFormat } from "./../Utils/Utils.js";
import Heading from "./../Elements/Heading";

const COLORS_ORANGE = ["#FAA461", "#f4f4f4"];
const COLORS_BLUE = ["#007bff", "#f4f4f4"];

class WatchingSummary extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => ({
    data: [
      this.props.data.data.views_unique && {
        Metric: "Video Views",
        Value: selectFormat(
          "number",
          this.props.data.data.views_unique.value,
          "0,0"
        ),
      },
      this.props.data.data.view_time && {
        Metric: "Minutes Watched",
        Value: selectFormat(
          "number",
          this.props.data.data.view_time.value,
          "0,0"
        ),
      },
      this.props.data.data.avg_view_time_per_view && {
        Metric: "Avg Min/View",
        Value: selectFormat(
          "number",
          this.props.data.data.avg_view_time_per_view.value,
          "0,0"
        ),
      },
      this.props.data.data.attributed_households && {
        Metric: "Attributed Household",
        Value: selectFormat(
          "number",
          this.props.data.data.attributed_households.value,
          "0,0"
        ),
      },
      this.props.data.data.unique_viewer && {
        Metric: "UVs Yesterday",
        Value: selectFormat(
          "number",
          this.props.data.data.unique_viewer.value,
          "0,0"
        ),
      },
      this.props.data.data.video_views_today && {
        Metric: "Video Views Yesterday",
        Value: selectFormat(
          "number",
          this.props.data.data.video_views_today.value,
          "0,0"
        ),
      },
      this.props.data.data.minutes_watched && {
        Metric: "Minutes Watched Yesterday",
        Value: selectFormat(
          "number",
          this.props.data.data.minutes_watched.value,
          "0,0"
        ),
      },
      this.props.data.data.avg_mins_per_viewer && {
        Metric: "AVG Mins Per Viewer Yesterday",
        Value: selectFormat(
          "number",
          this.props.data.data.avg_mins_per_viewer.value,
          "0,0"
        ),
      },
      this.props.data.data.first_viewers_chart && {
        Metric: "1st Time Viewers",
        Value: selectFormat(
          "percentage",
          this.props.data.data.first_viewers_chart[0].value,
          "%0.0"
        ),
      },
      this.props.data.data.first_viewers_chart && {
        Metric: "Returning Viewers",
        Value: selectFormat(
          "percentage",
          this.props.data.data.returning_viewers_chart[0].value,
          "%0.0"
        ),
      },
      this.props.data.data.first_viewers_chart && {
        Metric: "Users with Purchase",
        Value: selectFormat(
          "percentage",
          this.props.data.data.users_with_purchase_chart[0].value,
          "%0.0"
        ),
      },
      this.props.data.data.first_viewers_chart && {
        Metric: "Users without Purchase",
        Value: selectFormat(
          "percentage",
          this.props.data.data.users_without_purchase_chart[0].value,
          "%0.0"
        ),
      },
    ].filter(Boolean), // This will filter out any undefined entries
    opts: {
      type: "other",
    },
  });

  render() {
    const { data } = this.props;

    return (
      <Fragment>
        <div className="mt-2 row d-flex align-items-end">
          {data.data.views_unique && (
            <div className="col-6 col-md-3">
              <Heading size={6} className={"mb-1"}>
                Video Views
              </Heading>
              <Metric {...data.data.views_unique} size={"md"} />
            </div>
          )}

          {data.data.view_time && (
            <div className="col-6 col-md-3">
              <Heading size={6} className={"mb-1"}>
                Minutes Watched
              </Heading>
              <Metric {...data.data.view_time} size={"md"} />
            </div>
          )}

          {data.data.avg_view_time_per_view && (
            <div className="col-6 col-md-3">
              <Heading size={6} className={"mb-1"}>
                Avg Min/View
              </Heading>
              <Metric {...data.data.avg_view_time_per_view} size={"md"} />
            </div>
          )}

          {data.data.uniques_view_time && (
            <div className="col-6 col-md-3">
              <Heading size={6} className={"mb-1"}>
                Avg Min/View
              </Heading>
              <Metric
                {...data.data.uniques_view_time}
                size={"md"}
                type="percentage"
              />
            </div>
          )}

          {data.data.attributed_households && (
            <div className="col-6 col-md-3">
              <Heading size={6} className={"mb-1"}>
                Attributed Household
              </Heading>
              <Metric {...data.data.attributed_households} size={"md"} />
            </div>
          )}

          {data.data.unique_viewer && (
            <div className="col-6 col-md-3">
              <Heading size={6} className={"mb-1"}>
                UVs Yesterday
              </Heading>
              <Metric {...data.data.unique_viewer} size={"md"} />
            </div>
          )}

          {data.data.video_views_today && (
            <div className="mb-3 col-6 col-md-3 mb-md-0">
              <Heading size={6} className={"mb-1"}>
                Video Views Yesterday
              </Heading>
              <Metric {...data.data.video_views_today} size={"md"} />
            </div>
          )}

          {data.data.minutes_watched && (
            <div className="mb-3 col-6 col-md-3 mb-md-0">
              <Heading size={6} className={"mb-1"}>
                Minutes Watched Yesterday
              </Heading>
              <Metric {...data.data.minutes_watched} size={"md"} />
            </div>
          )}

          {data.data.avg_mins_per_viewer && (
            <div className="col-6 col-md-3">
              <Heading size={6} className={"mb-1"}>
                AVG Mins Per Viewer Yesterday
              </Heading>
              <Metric {...data.data.avg_mins_per_viewer} size={"md"} />
            </div>
          )}
        </div>

        <div className="mt-4 row">
          {data.data.first_viewers_chart && (
            <div className="col-auto mr-3 d-flex flex-column align-items-center">
              <Heading size={6} className={"mb-1"}>
                1<sup>st</sup> Time Viewers
              </Heading>
              <PieChart height={70} width={70}>
                <Pie
                  dataKey="value"
                  data={data.data.first_viewers_chart}
                  outerRadius="100%"
                  innerRadius="70%"
                >
                  {data.data.first_viewers_chart.map((entry, index) => (
                    <Cell key={`cell-${entry}`} fill={COLORS_ORANGE[index]} />
                  ))}
                </Pie>
                <text
                  x="50%"
                  y="50%"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  className="piechart-metric__small"
                >
                  {selectFormat(
                    "percentage",
                    data.data.first_viewers_chart[0].value,
                    "%0.0"
                  )}
                </text>
              </PieChart>
            </div>
          )}

          {data.data.returning_viewers_chart && (
            <div className="col-auto mr-3 d-flex flex-column align-items-center">
              <Heading size={6} className={"mb-1"}>
                Returning Viewers
              </Heading>
              <PieChart height={70} width={70}>
                <Pie
                  dataKey="value"
                  data={data.data.returning_viewers_chart}
                  outerRadius="100%"
                  innerRadius="70%"
                >
                  {data.data.returning_viewers_chart.map((entry, index) => (
                    <Cell key={`cell-${entry}`} fill={COLORS_ORANGE[index]} />
                  ))}
                </Pie>
                <text
                  x="50%"
                  y="50%"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  className="piechart-metric__small"
                >
                  {selectFormat(
                    "percentage",
                    data.data.returning_viewers_chart[0].value,
                    "%0.0"
                  )}
                </text>
              </PieChart>
            </div>
          )}

          {data.data.returning_viewers_chart &&
            data.data.users_with_purchase_chart && (
              <div
                style={{
                  height: "70px",
                  width: "3px",
                  borderRight: "1px dotted #ccc",
                  margin: "5px 20px",
                }}
              ></div>
            )}

          {data.data.users_with_purchase_chart && (
            <div className="col-auto mr-3 d-flex flex-column align-items-center">
              <Heading size={6} className={"mb-1"}>
                Users with Purchase
              </Heading>
              <PieChart height={70} width={70}>
                <Pie
                  dataKey="value"
                  data={data.data.users_with_purchase_chart}
                  outerRadius="100%"
                  innerRadius="70%"
                >
                  {data.data.users_with_purchase_chart.map((entry, index) => (
                    <Cell key={`cell-${entry}`} fill={COLORS_BLUE[index]} />
                  ))}
                </Pie>
                <text
                  x="50%"
                  y="50%"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  className="piechart-metric__small"
                >
                  {selectFormat(
                    "percentage",
                    data.data.users_with_purchase_chart[0].value,
                    "%0.0"
                  )}
                </text>
              </PieChart>
            </div>
          )}

          {data.data.users_without_purchase_chart && (
            <div className="col-auto mr-3 d-flex flex-column align-items-center">
              <Heading size={6} className={"mb-1"}>
                Users without Purchase
              </Heading>
              <PieChart height={70} width={70}>
                <Pie
                  dataKey="value"
                  data={data.data.users_without_purchase_chart}
                  outerRadius="100%"
                  innerRadius="70%"
                >
                  {data.data.users_without_purchase_chart.map(
                    (entry, index) => (
                      <Cell key={`cell-${entry}`} fill={COLORS_BLUE[index]} />
                    )
                  )}
                </Pie>
                <text
                  x="50%"
                  y="50%"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  className="piechart-metric__small"
                >
                  {selectFormat(
                    "percentage",
                    data.data.users_without_purchase_chart[0].value,
                    "%0.0"
                  )}
                </text>
              </PieChart>
            </div>
          )}

          {data.data.pie_charts?.power_watchers && (
            <div className="col-auto mr-3 d-flex flex-column align-items-center">
              <Heading size={6} className={"mb-1"}>
                Power Watchers{" "}
                <div
                  className="with-tooltip"
                  data-tooltip-id="watching-summary-tooltip"
                  data-tooltip-html="30+ Starts in the last 30 days"
                ></div>
              </Heading>
              <PieChart height={70} width={70}>
                <Pie
                  dataKey="value"
                  data={data.data.pie_charts.power_watchers}
                  outerRadius="100%"
                  innerRadius="70%"
                >
                  {data.data.pie_charts.power_watchers.map((entry, index) => (
                    <Cell key={`cell-${entry}`} fill={COLORS_ORANGE[index]} />
                  ))}
                </Pie>
                <text
                  x="50%"
                  y="50%"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  className="piechart-metric__small"
                >
                  {selectFormat(
                    "percentage",
                    data.data.pie_charts.power_watchers[0].value / 100,
                    "%"
                  )}
                </text>
              </PieChart>
            </div>
          )}

          {data.data.pie_charts?.regular_watchers && (
            <div className="col-auto mr-3 d-flex flex-column align-items-center">
              <Heading size={6} className={"mb-1"}>
                Regular Watchers
                <div
                  className="with-tooltip"
                  data-tooltip-id="watching-summary-tooltip"
                  data-tooltip-html="10-29 Starts in the last 30 days"
                ></div>
              </Heading>
              <PieChart height={70} width={70}>
                <Pie
                  dataKey="value"
                  data={data.data.pie_charts.regular_watchers}
                  outerRadius="100%"
                  innerRadius="70%"
                >
                  {data.data.pie_charts.regular_watchers.map((entry, index) => (
                    <Cell key={`cell-${entry}`} fill={COLORS_ORANGE[index]} />
                  ))}
                </Pie>
                <text
                  x="50%"
                  y="50%"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  className="piechart-metric__small"
                >
                  {selectFormat(
                    "percentage",
                    data.data.pie_charts.regular_watchers[0].value / 100,
                    "%"
                  )}
                </text>
              </PieChart>
            </div>
          )}

          {data.data.pie_charts?.occasional_watchers && (
            <div className="col-auto mr-3 d-flex flex-column align-items-center">
              <Heading size={6} className={"mb-1"}>
                Occasional Watchers
                <div
                  className="with-tooltip"
                  data-tooltip-id="watching-summary-tooltip"
                  data-tooltip-html="< 10 Starts in the last 30 days"
                ></div>
              </Heading>
              <PieChart height={70} width={70}>
                <Pie
                  dataKey="value"
                  data={data.data.pie_charts.occasional_watchers}
                  outerRadius="100%"
                  innerRadius="70%"
                >
                  {data.data.pie_charts.occasional_watchers.map(
                    (entry, index) => (
                      <Cell key={`cell-${entry}`} fill={COLORS_ORANGE[index]} />
                    )
                  )}
                </Pie>
                <text
                  x="50%"
                  y="50%"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  className="piechart-metric__small"
                >
                  {selectFormat(
                    "percentage",
                    data.data.pie_charts.occasional_watchers[0].value / 100,
                    "%"
                  )}
                </text>
              </PieChart>
            </div>
          )}

          <ReactTooltip
            id="watching-summary-tooltip"
            className="title-tooltip"
          />
        </div>
      </Fragment>
    );
  }
}

export default WatchingSummary;
